import { Dispatch, SetStateAction, useContext, useEffect } from 'react';

import Rolling from '@assets/gif/rolling.gif';
import { CreateUpdateContext } from '@components/CreateUpdatesDialog/CreateUpdatesDialog.query';
import { IManufacturerCreateUpdate } from '@models/Manufacturer.model';
import { getManufacturersCreateUpdate } from '@services/queries/manufacturers';
import { useInView } from 'react-intersection-observer';
import { useInfiniteQuery, useQueryClient } from 'react-query';

import {
  Container,
  Content,
  LabelText,
  LoadingImg,
  LoadingText,
  LoadMore,
  Row,
  TableContent,
} from './MenuContent.styles';

import { MenuContentLoading } from './MenuContent.loading';

interface IMenuContent {
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const MenuContent = ({ setOpen }: IMenuContent) => {
  const {
    searchManufacturer,
    setSelectedMenufacturers,
    selectedMenufacturers,
  } = useContext(CreateUpdateContext);

  const { ref, inView } = useInView();

  const queryClient = useQueryClient();

  const { data, isLoading, fetchNextPage } = useInfiniteQuery(
    ['createUpdate', 'manufacturers', searchManufacturer.get()],
    async ({ pageParam = 1 }) => {
      const studioUpdates = await getManufacturersCreateUpdate({
        page: pageParam,
        limit: 20,
        search: searchManufacturer.get(),
      });

      return studioUpdates;
    },
    {
      getNextPageParam: lastPage =>
        lastPage.hasMore ? lastPage.currentPage + 1 : undefined,
    },
  );

  const hasMore = data ? data.pages[data.pages.length - 1].hasMore : false;

  useEffect(() => {
    if (inView && hasMore) fetchNextPage();
  }, [inView]);

  const toggleSelectedManufacturer = (
    manufacturer: IManufacturerCreateUpdate,
  ) => {
    const findIndex = selectedMenufacturers.findIndex(
      item => item.id === manufacturer.id,
    );

    if (findIndex !== -1) {
      setSelectedMenufacturers([]);
    } else {
      setSelectedMenufacturers([manufacturer]);
    }
  };

  const manufacturers = data?.pages
    .map(pageData => pageData.results)
    .reduce(function reduce(prev, next) {
      return prev.concat(next);
    });

  return (
    <Container>
      <Content>
        {isLoading && !data ? (
          <MenuContentLoading />
        ) : (
          <>
            {manufacturers?.map(manufacturerItem => {
              return (
                <TableContent>
                  <Row
                    onClick={() => {
                      toggleSelectedManufacturer(manufacturerItem);
                      queryClient.resetQueries([
                        'createUpdate',
                        'manufacturers',
                      ]);
                      setOpen(false);
                    }}
                  >
                    <LabelText className="tabble-row" limitOfLines={1}>
                      {manufacturerItem.name}
                    </LabelText>
                  </Row>
                </TableContent>
              );
            })}

            <LoadMore ref={ref}>
              {hasMore ? (
                <>
                  <LoadingText>Loading more</LoadingText>
                  <LoadingImg src={Rolling} alt="loading" />
                </>
              ) : (
                <>
                  <LoadingText>End of List</LoadingText>
                </>
              )}
            </LoadMore>
          </>
        )}
      </Content>
    </Container>
  );
};

export { MenuContent };
